import React, { Component } from 'react';
import Card from 'components/helpers/Card';

import { connect } from 'react-redux';
import { fetchAccount, updateAccountPhoto, editAccount } from 'views/account/_actions';
import { Row, Col, Button } from 'reactstrap';
import { Formik, Form } from 'formik';
import { UploadProfilePhoto, Text } from 'components/inputs';
import { getInitialValues, getValuesAsFormData } from 'utils/form';
import PrivateHeader from 'components/layouts/PrivateHeader';

class Profile extends Component {
  _initialValues = {
    id: '',
    name: '',
    email: '',
    mobile: '',
    photo: ''
  };

  componentDidMount() {
    this.props.fetchAccount();
  }

  updateAccount = (values, action) => {
    let formData = {
      ...values,
      photo: undefined
    };

    if (typeof values.photo === 'object') {
      const params = getValuesAsFormData({ photo: values.photo }, false, true);
      this.props.updateAccountPhoto(params);
    }

    this.props.editAccount(formData).then(p => {
      action.setSubmitting(false);
    });
  };

  renderBody = () => {
    const { account } = this.props;
    const initialValues = getInitialValues(this._initialValues, account);

    return (
      account && (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={this.updateAccount}
          render={({
            values,
            handleChange,
            isSubmitting,
            setFieldValue,
            errors,
            touched,
            resetForm,
            dirty
          }) => (
            <Form>
              <Row>
                <Col xs={'auto'}>
                  <UploadProfilePhoto
                    id={1}
                    name="photo"
                    photo={values.photo}
                    square={false}
                    onChange={file => setFieldValue('photo', file)}
                  />
                </Col>
                <Col className="pl-4">
                  <Row>
                    <Col>
                      <Text
                        label="Name"
                        labelClassName="py-0 pl-1"
                        placeholder="Name"
                        type="text"
                        className="material mb-2 input-icon"
                        value={values.name}
                        name={`name`}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Text
                        disabled
                        label="Email"
                        labelClassName="py-0 pl-1"
                        placeholder="Email"
                        type="email"
                        className="material mb-2"
                        value={values.email}
                        name={`email`}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Text
                        label="Mobile Number"
                        labelClassName="py-0 pl-1"
                        placeholder="Mobile Number"
                        disabled
                        type="text"
                        className="material mb-2"
                        value={values.mobile}
                        name={`mobile`}
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3 flex-row-reverse">
                    <Col xs="auto">
                      <Button color="info" className="min-96" disabled={isSubmitting || !dirty}>
                        Save
                      </Button>
                    </Col>
                    <Col xs="auto" className="pr-0 ">
                      <Button
                        className="min-96 btn-cancel"
                        onClick={() => resetForm()}
                        color="danger"
                        disabled={!dirty}
                      >
                        Cancel
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        />
      )
    );
  };

  render() {
    return (
      <div className="dash-wrapper">
        <h1 className="mb-0 title">My Profile</h1>
        <PrivateHeader title={'My Profile'} />

        <Row>
          <Col className="col-12 col-lg-10 col-lap-6 col-hd-4">
            <Card className="p-1 mt-7" bodyClassName={'p-2'} body={this.renderBody()} />
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    account: state.account
  };
}

export default connect(
  mapStateToProps,
  { fetchAccount, updateAccountPhoto, editAccount }
)(Profile);



// WEBPACK FOOTER //
// ./src/views/profile/index.js